module.exports = __webpack_public_path__ + "static/media/PUBLICATIONS.c8bad4f1.pdf";